// extracted by mini-css-extract-plugin
export default {"featchLoading":"ProductLauncherPage_featchLoading__YOW-E"};